import { Tag, TagLabel, TagLeftIcon } from "@chakra-ui/react";
import { t } from "i18next";
import { FaCheckCircle, FaUnlink } from "react-icons/fa";
import { Explanation } from "../../../common/support/Explanation/Explanation";

export const OrgProfileStatusTag = ({ isRegistered }: { isRegistered: boolean }) => {
  if (isRegistered)
    return (
      <Explanation enabled text={t("This company is registered on the platform and managed by its representatives")}>
        <Tag colorScheme="blue" variant="subtle" size="md" whiteSpace="nowrap">
          <TagLeftIcon as={FaCheckCircle} />
          <TagLabel>{t("Registered company")}</TagLabel>
        </Tag>
      </Explanation>
    );

  return (
    <Explanation enabled text={t("This company is self-registered by your org and is not linked to a registered company")}>
      <Tag colorScheme="orange" variant="subtle" size="md" whiteSpace="nowrap">
        <TagLeftIcon as={FaUnlink} />
        <TagLabel>{t("Self-registered · not linked")}</TagLabel>
      </Tag>
    </Explanation>
  );
};
